export default "__VITE_ASSET__piuZNOxi__"